export const getLanguageTitle = (lang) => {
    switch (lang) {
        case 'RU':
            return 'Russian'
        case 'DE':
            return 'Deutch'
        case 'ES':
            return 'Spanish'
        case 'FR':
            return 'French'
        case 'PT':
            return 'Portuguese'
        case 'NL':
            return 'Dutch'
        default:
            return 'English'
    }
}

export const getLanguageIcon = (lang) => {
    let icon
    switch (lang) {
        case 'RU':
            icon = 'ru'
            break
        case 'DE':
            icon = 'deu'
            break
        case 'ES':
            icon = 'es'
            break
        case 'FR':
            icon = 'fr'
            break
        case 'PT':
            icon = 'pt'
            break
        case 'NL':
            icon = 'nl'
            break
        default:
            icon = 'usa'
            break
    }
    return '/images/useful/svg/theme/symbol-defs.svg#icon-' + icon
}